import networkingImg from "../assets/twocore.svg";
import brandingImg from "../assets/x7digiads.svg";

export default function ServicesCards() {
  const companies = [
    {
      name: "Two Core Networking",
      image: networkingImg,
      tagline: "A Data Security & Networking company",
      link: null,
    },
    {
      name: "X7 DIGI ADS",
      image: brandingImg,
      tagline: "A Digital Marketing & Advertising company",
      link: "https://x7digiads.com",
    },
  ];

  return (
    <section className="py-16 px-6 md:px-16 overflow-hidden">
      {/* ✅ Heading */}
      <h2 className="text-4xl font-bold text-gray-800 text-center mb-10">
        Our Sister Companies
      </h2>

      {/* ✅ Cards */}
      <div className="flex flex-col md:flex-row justify-center items-center gap-48">
        {companies.map((company, index) => (
          <div
            key={index}
            className="group bg-white rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 w-full max-w-md flex flex-col items-center text-center p-10 border border-gray-100"
          >
            {company.link ? (
              <a
                href={company.link}
                target="_blank"
                rel="noopener noreferrer"
                className="w-48 h-48 mb-5 flex items-center justify-center bg-gray-100 rounded-full overflow-hidden"
              >
                <img
                  src={company.image}
                  alt={company.name}
                  className="w-40 h-40 object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </a>
            ) : (
              <div className="w-48 h-48 mb-5 flex items-center justify-center bg-gray-100 rounded-full overflow-hidden">
                <img
                  src={company.image}
                  alt={company.name}
                  className="w-40 h-40 object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            )}

            {company.link ? (
              <a
                href={company.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl font-semibold text-gray-800 mb-2 transition-colors hover:text-blue-600"
              >
                {company.name}
              </a>
            ) : (
              <h3 className="text-2xl font-semibold text-gray-800 mb-2">
                {company.name}
              </h3>
            )}

            {/* ✅ Tagline */}
            <p className="text-gray-500 text-lg italic tracking-wide">
              {company.tagline}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
